export default __webpack_public_path__ + "static/media/logo.d6b220e4.png";